import {
  Companion_getInstance183u30r0z0tam as Companion_getInstance,
  CouplingImagesci5yi3b0zpw0 as CouplingImages,
} from '../../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/CouplingImages.mjs';
import com_zegreatrob_coupling_client_components_overlayPng_4zja5b from '/images/overlay.png';
import com_zegreatrob_coupling_client_components_graphqlSvg_5pzxul from '/images/graphql.svg';
import com_zegreatrob_coupling_client_components_logoSvg_wdak4v from '/images/logo.svg';
import com_zegreatrob_coupling_client_components_noPartyImagePath_4z2x25 from '/images/parties/no-party.png';
import com_zegreatrob_coupling_client_components_noPlayerImagePath_9khyqe from '/images/players/autumn.png';
import com_zegreatrob_coupling_client_components_frodo_spaifa from '/images/players/frodo.png';
import com_zegreatrob_coupling_client_components_samwise_76t0dh from '/images/players/samwise.png';
import com_zegreatrob_coupling_client_components_grayson_xe4s7t from '/images/players/grayson.png';
import com_zegreatrob_coupling_client_components_wayne_sycddq from '/images/players/wayne.png';
import com_zegreatrob_coupling_client_components_rosie_svu7nu from '/images/players/rosie.png';
import com_zegreatrob_coupling_client_components_wendy_syeoy5 from '/images/players/wendy.png';
import com_zegreatrob_coupling_client_components_robPng_rzrh6c from '/images/players/rob.png';
import com_zegreatrob_coupling_client_components_autumnPng_9u4ctx from '/images/players/autumn.png';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function loadImages() {
  Companion_getInstance().m3q_1 = new (CouplingImages())(com_zegreatrob_coupling_client_components_overlayPng_4zja5b, com_zegreatrob_coupling_client_components_graphqlSvg_5pzxul, com_zegreatrob_coupling_client_components_logoSvg_wdak4v, com_zegreatrob_coupling_client_components_noPartyImagePath_4z2x25, com_zegreatrob_coupling_client_components_noPlayerImagePath_9khyqe, com_zegreatrob_coupling_client_components_frodo_spaifa, com_zegreatrob_coupling_client_components_samwise_76t0dh, com_zegreatrob_coupling_client_components_grayson_xe4s7t, com_zegreatrob_coupling_client_components_wayne_sycddq, com_zegreatrob_coupling_client_components_rosie_svu7nu, com_zegreatrob_coupling_client_components_wendy_syeoy5, com_zegreatrob_coupling_client_components_robPng_rzrh6c, com_zegreatrob_coupling_client_components_autumnPng_9u4ctx);
}
//region block: exports
export {
  loadImages as loadImages3hq91znq8rg8h,
};
//endregion

//# sourceMappingURL=ImagePath.mjs.map
